






















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import { InvoiceStatsDto } from '@/data/web-api-client';
import invoicesRepository from '../services/invoicesRepository';
import { debounce } from 'lodash';
import formatBelgianCurrency from '@/helpers/currencyHelper';

@Component({
  components: {},
})
export default class InvoicesBillingStats extends Vue {
  @Prop({ required: true, default: '' })
  projectId!: string;

  @Prop({ required: false })
  public metadata?: string;

  @Prop({ required: false })
  public loadOptions: any;

  loading: boolean = true;
  stats: InvoiceStatsDto | null = null;

  invoices: any[] = [];

  declare currency: any;
  loaded: boolean = false;

  async mounted() {
    this.loaded = this.loadOptions != undefined;
  }

  async loadData() {
    if (this.loadOptions == undefined) {
      return;
    }

    try {
      let loadOptions = { ...this.loadOptions };

      this.loading = true;
      loadOptions.take = 9999;
      if (loadOptions.searchExpr == undefined) {
        loadOptions.searchExpr = '';
      }

      const result = await invoicesRepository.lookup(loadOptions, this.projectId, this.metadata);

      const activeInvoices = result.data.data.filter((i: any) => i.status && i.status > 1);
      this.invoices = [...activeInvoices];
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loading = false;
    }
  }

  get totalExcl() {
    const result = this.invoices.map((i) => i.total).reduce((partialSum, newTotalExcl) => partialSum + newTotalExcl, 0);

    return formatBelgianCurrency(result);
  }

  get totalIncl() {
    const result = this.invoices.map((i) => i.totalWithTax).reduce((partialSum, newTotalIncl) => partialSum + newTotalIncl, 0);

    return formatBelgianCurrency(result);
  }

  get totalToPay() {
    const result = this.invoices.map((i) => i.toPay).reduce((partialSum, newTotaltoPay) => partialSum + newTotaltoPay, 0);

    return formatBelgianCurrency(result);
  }

  get totalMargin() {
    const result = this.invoices.map((i) => i.margin).reduce((partialSum, newTotalMargin) => partialSum + newTotalMargin, 0);

    return formatBelgianCurrency(result);
  }

  @Watch('loadOptions', { immediate: true, deep: true })
  onLoadOptionsChange(value: any, oldValue: any) {
    debounce(() => {
      if (value) {
        this.loadData();
      }
    }, 500)();
  }
}
